<template>
    <el-drawer
        :title="!id ? '新增元素' : '管理元素'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
		append-to-body
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                v-loading="dataLoading"
            >	
                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12">
                        <el-form-item prop="status" label="状态:" >
                            <el-select v-model="formData.status" size="medium">
                                <el-option :value="1" label="展示"></el-option>
                                <el-option :value="0" label="隐藏"></el-option>				        
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item prop="name" label="名称:">
                            <el-input
                                v-model="formData.name"
                                placeholder="请输入名称"
                                size="medium"
                                :maxlength="40"
                            ></el-input>					
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item prop="mark" label="标识:">
                            <el-input
                                v-model="formData.mark"
                                placeholder="请输入标识"
                                size="medium"
                                :maxlength="40"
                            ></el-input>
                            <small class="from-tip"><span class="el-icon-warning"></span>同类型资源有顺序要求时，标识名称请带上序号，如：abc_01、abc_02、abc_10</small>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item prop="groupName" label="组">
                            <el-input
                                v-model="formData.groupName"
                                placeholder="请输入组的名称"
                                size="medium"
                                :maxlength="40"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>			
				<el-form-item prop="type" label="内容类型:">
				    <el-radio-group 
						v-model="formData.type" 
						@change="scopeChange"
						size="medium"
					>
				        <el-radio :label="1">纯图片</el-radio>
				        <el-radio :label="2">纯文字</el-radio>
				        <el-radio :label="3">富文本</el-radio>
                        <el-radio :label="4">SVGA</el-radio>
                        <el-radio :label="5">音频</el-radio>
                        <el-radio :label="6">视频</el-radio>
				    </el-radio-group>
				</el-form-item>

				<el-form-item v-if="formData.type != 6" label="内容:" prop="content" required>
					<template v-if="formData.type === 1">
					   <image-upload
					       :url.sync="formData.content" 
					       :urlFull.sync="formData.content" 
					       @onSuccess="handleSuccess"
					   ><span slot="size">无特殊要求</span></image-upload>
					</template>
				  <template v-else-if="formData.type === 2">
					  <el-input type="textarea"  v-model="formData.content" maxlength="10000" placeholder="输入纯文字内容"></el-input>
				  </template>				  
				  <template v-else-if="formData.type === 3 && reFresh">
					   <tinymce v-model="formData.content" :height="500" :toolbar="toolbar" :menubar="false" ></tinymce>
				  </template>
                  <template v-else-if="(formData.type === 4)">
                    <svga-upload :url.sync="formData.content" :urlFull.sync="formData.content" @onSuccess="handleSuccess"></svga-upload>
				  </template>
                  <template v-else-if="(formData.type === 5)">
                    <div class="fl MR20">
                        <el-upload 
                            action
                            :http-request="uploadMusic"
                            ref="uploadMp3"
                            accept="audio/mpeg,audio/wav"
                            :show-file-list="false"
                            :disabled="uploadMP3Loading"
                        >
                            <el-button type="primary" icon="el-icon-upload" size="medium" :loading="uploadMP3Loading">上传MP3或WAV</el-button>
                        </el-upload>
                    </div>
                    <el-button v-if="formData.content" size="medium" type="text" icon="el-icon-video-play" @click="$player.play({playUrl:formData.content})">试听</el-button>
				  </template>
				</el-form-item>

                <el-row v-else :gutter="30">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="内容:" prop="content" required>
                            <video-upload :url.sync="formData.content" :urlFull.sync="formData.content"
                                :cover.sync="formData.videoPhoto" @onSuccess="$refs.formData.clearValidate('content')">
                            </video-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item prop="videoPhoto" label="视频封面:">
                            <image-upload :url.sync="formData.videoPhoto" :urlFull.sync="formData.videoPhoto"></image-upload>
                        </el-form-item>
                    </el-col>
                </el-row>

				<el-form-item prop="link" label="跳转链接:">
				    <el-input
				        v-model="formData.link"
				        placeholder="请输入跳转链接"
				        size="medium"
						:maxlength="200"
				    ></el-input>					
				</el-form-item>

				<el-form-item prop="remark" label="描述说明:">
                    <tinymce v-if="reFresh" v-model="formData.remark" :height="400" :toolbar="toolbar" :menubar="false" ></tinymce>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
import Tinymce from '@/components/Tinymce'; 
import SvgaUpload from '@/components/SvgaUpload';
import {uploadAudio} from '@/assets/js/commonApi'
import VideoUpload from "@/components/VideoUpload";

const defaultFormData = {
    status:1,
    name:'',
    mark:'',
    groupName:'resources',
	type:1,
	content:'',
	link:''	,
	remark:'',
    videoPhoto: ''
}
export default {
	components:{
	    ImageUpload,
		Tinymce,
        SvgaUpload,
        VideoUpload
	},
	props: {
	    pageShareConfigId: {
	        type: [Number, String],
	        default: null,
	    },
	},
    data() {
        return {
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            formData: {
                ...defaultFormData
            },
            rules: {
                name: [{ required: true, message: "请输入名称" }],
                mark: [{ required: true, message: "请输入标识" }],
                groupName: [{ required: true, message: "请输入组的名称" }],
				content: [{ required: true, message: "请输入内容" }],				
            },
			id:'',			
		    toolbar:['formatselect fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify | image media | preview fullscreen'],
            uploadMP3Loading: false,
            reFresh: false
        };
    },
	
    methods: {
        close() {
            this.formData = {...defaultFormData};           
            this.$refs.formData.resetFields();
            this.reFresh = false;
            this.drawerShow = false;
        },
        show(id) {			
            this.id = id;			
            if(this.id){
                this.getDataDetail();
            }else{
                this.reFresh = true
            }
            this.drawerShow = true;
        },
		
        //获取详情
        getDataDetail() {
			
            this.dataLoading = true;
            this.$request({
                url: "/h5/resource/info",
                params: { id: this.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {                       
                        
                        this.formData = {
                            ...result,						
                        };                        
						
                    } else {
                       this.$message.error(msg || "操作失败,请重试");
                    }
                    this.$nextTick(() => {
                        this.reFresh = true;
                    })
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
		handleSuccess(){
		//    const _type = file.file.type, _name = file.file.name;
		//    this.formData.bmp = _type.substring(_type.lastIndexOf('/')+1);
		   // this.formData.imgName = _name;
		   this.$refs["formData"].clearValidate('content');
		},
		//范围切换
		scopeChange(e) {
		    if (e != 1) {
		        this.formData.content = "";
		    }
		},
        async uploadMusic(req){
            const {file} = req;
            console.log(file.type);
            const isType = file.type === 'audio/mpeg' || file.type === 'audio/wav';
            if (!isType) {
                return this.$message.error('只能上传MP3或WAV格式的音频!');
            }

            this.uploadMP3Loading = true;
            const formData = new FormData();
            formData.append('file', file);

            // let filePath;
            const res = await uploadAudio(formData).catch(err => {
                this.$message({message: err.message, type: 'error'});
                this.formData.content = '';
            }).finally(() => {
                this.uploadMP3Loading = false;
            });
            const{state,msg,result} = res.data;
            if (state == 1 && result) {
                this.formData.content = result.urlFull;
            }else{
                this.$message.error(msg || '上传失败');
                this.formData.content = '';
            }
        },
        //表单提交
        submitForm() {
            let self = this;
            
            self.$refs["formData"].validate((valid) => {
                if (valid) {                   
                    
                    this.btnLoading = true;
					console.log(this.pageShareConfigId)
                    this.$request({
                        url: "/h5/resource/save",                       
						data: {...this.formData,pageShareConfigId:this.pageShareConfigId},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('update');
                                self.close();
                            } else {
                                self.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    },
};
</script>
